export default __webpack_public_path__ + "static/media/app-intro-desktop.e65c07b6.svg";